import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';

// Components
import {
  I18n,
  Table,
  Link,
} from 'components';

// Utils
import { formatUnitString } from 'utils/formatString';

// Constants
import classNames from 'classnames/bind';
import { EXPENSES_SECTIONS } from '../../constants';

// Styles
import styles from './styles.pcss';
const cx = classNames.bind(styles);

const calculateTotalAmount = (structure, filters) => {
  if (structure && filters) {
    return structure
      .filter((s) => !s.nested)
      .reduce((acc, curr, index) => (
        filters[index].activeIn[EXPENSES_SECTIONS.STRUCTURE] ? acc + curr.sum : acc
      ), 0);
  }

  return 0;
};

const areAllFiltersActive = (filters) => filters && filters
  .every((filter) => filter.activeIn[EXPENSES_SECTIONS.STRUCTURE]);

class TotalSpent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isDiscountExpanded: false,
    };
  }

  render() {
    const {
      structure,
      filters,
      currency,
      penalties,
      discountParams,
      discountValue,
      vat,
      amount,
    } = this.props;

    const { isDiscountExpanded } = this.state;

    const totalSpent = calculateTotalAmount(structure, filters);
    const areFiltersActive = areAllFiltersActive(filters);

    return (
      <div className={cx('component', isEmpty(filters) && 'empty')}>
        <div className={cx('row')}>
          <I18n
            className={cx('spendingName')}
            path="detalization.postpaidInvoices.invoice.totalSpent"
          />
          <div className={cx('spendingValue')}>
            {formatUnitString(totalSpent, currency)}
          </div>
        </div>
        {!!penalties && areFiltersActive && (
          <div className={cx('row')}>
            <I18n
              className={cx('spendingName')}
              path="detalization.postpaidInvoices.invoice.penalties"
            />
            <div className={cx('spendingValue')}>
              +
              {' '}
              {formatUnitString(penalties, currency)}
            </div>
          </div>
        )}
        {!!discountValue && areFiltersActive && (
          <div className={cx('row')}>
            <Link
              className={cx('spendingName')}
              onClick={() => this.setState({ isDiscountExpanded: !isDiscountExpanded })}
            >
              <I18n path="detalization.postpaidInvoices.invoice.discount" />
            </Link>
            <div className={cx('spendingValue')}>
              -
              {' '}
              {formatUnitString(discountValue, currency)}
            </div>
            {discountParams && isDiscountExpanded && (
              <div>
                <div className={cx('arrow')} />
                <div className={cx('table')}>
                  <Table
                    data={discountParams}
                    config={{
                      columns: [
                        {
                          name: 'detalization.postpaidInvoices.invoice.discountName',
                          dataField: 'name',
                        },
                        {
                          name: 'detalization.postpaidInvoices.invoice.percentage',
                          dataField: 'percent',
                          transformer: ({ percent }) => `${percent}%`,
                        },
                        {
                          name: 'detalization.postpaidInvoices.invoice.discountAmount',
                          dataField: 'amount',
                          transformer: ({ amount }) => formatUnitString(amount, currency),
                        },
                        {
                          name: 'detalization.postpaidInvoices.invoice.discountResult',
                          dataField: 'discountResult',
                          transformer: ({ discountResult }) => formatUnitString(discountResult, currency),
                        },
                      ],
                      uniqueIdField: 'name',
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        )}

        {!!vat && (
          <div className={cx('row')}>
            <I18n
              className={cx('spendingName')}
              path="detalization.postpaidInvoices.invoice.vat"
            />
            <div className={cx('spendingValue')}>
              +
              {' '}
              {formatUnitString(vat, currency)}
            </div>
          </div>
        )}
        {!!amount && (
          <div className={cx('row')}>
            <I18n
              className={cx('spendingName', 'totalName')}
              path="detalization.postpaidInvoices.invoice.total"
            />
            <div className={cx('spendingValue')}>
              {formatUnitString(amount, currency)}
            </div>
          </div>
        )}
      </div>
    );
  }
}

TotalSpent.propTypes = {
  structure: PropTypes.array,
  filters: PropTypes.array,
  currency: PropTypes.string,
  penalties: PropTypes.number,
  discountParams: PropTypes.array,
  discountValue: PropTypes.number,
  amount: PropTypes.number,
  vat: PropTypes.number,
};

export default TotalSpent;
